import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api, { tScenarioOrigin, tScenarioStatus, SCENARIO_STATUS } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { GitBranch, ArrowRight, Loader2 } from "lucide-react";

function StatusBadge({ value }) {
  const c = SCENARIO_STATUS[value] || SCENARIO_STATUS.draft;
  return <Badge variant="outline" className={`rounded-sm text-[10px] font-mono ${c.cls}`}>{tScenarioStatus(value)}</Badge>;
}

// Panneau LECTURE SEULE réutilisable — « Scénarios liés » (Service / Threat / Vulnerability / Technique).
export default function ScenariosPanel({ endpoint, queryKey }) {
  const navigate = useNavigate();
  const { data = [], isLoading } = useQuery({
    queryKey,
    queryFn: async () => (await api.get(endpoint)).data,
  });

  return (
    <section className="border border-border bg-card rounded-sm" data-testid="section-linked-scenarios">
      <div className="px-6 py-4 border-b border-border flex items-center gap-2">
        <GitBranch className="h-4 w-4 text-primary" />
        <h2 className="font-head font-semibold text-sm">Scénarios liés — {data.length}</h2>
      </div>
      <div className="p-6">
        {isLoading ? (
          <p className="text-sm text-muted-foreground flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Chargement…</p>
        ) : data.length === 0 ? (
          <p className="text-sm text-muted-foreground">Aucun scénario ne référence cet élément.</p>
        ) : (
          <div className="space-y-2">
            {data.map((s) => (
              <button key={s.id} onClick={() => navigate(`/scenarios/${s.id}`)}
                className="w-full flex items-center justify-between gap-3 border border-border rounded-sm px-3 py-2 text-left hover:border-primary/50 transition-colors"
                data-testid={`linked-scenario-${s.id}`}>
                <span className="flex items-center gap-2 text-sm">
                  <span className="font-medium">{s.title}</span>
                  <span className="text-[10px] font-mono text-muted-foreground">{tScenarioOrigin(s.origin)} · {s.steps} étape(s)</span>
                </span>
                <span className="flex items-center gap-2"><StatusBadge value={s.status} /><ArrowRight className="h-4 w-4 text-muted-foreground" /></span>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
